import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../Roles and Permissions/Filters/MultiSelect";
import AddData from "../../Scope3/Transportation&Distribution/Vehicle/AddVehicle";
import ViewVehicle from "../../Scope3/Transportation&Distribution/Vehicle/ViewVehicle";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const Scope1Vehicle = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addVehicle, setAddVehicle] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Transport Type": false,
    Ownership: false,
    "Logistics Vendor": false,
    Brand: false,
    Model: false,
  });
  const [viewVehicle, setViewVehicle] = useState(false);
  const [vehicle, setVehicle] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Transport Type": false,
    Ownership: false,
    "Logistics Vendor": false,
    Brand: false,
    Model: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    transportType: [],
    ownership: [],
    logisticsVendor: [],
    brand: [],
    model: [],
  });
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    transportType: [],
    ownership: [],
    logisticsVendor: [],
    brand: [],
    model: [],
  });

  const filters = [
    "Date",
    "Transport Type",
    "Ownership",
    "Logistics Vendor",
    "Brand",
    "Model",
  ];

  const inputData = [
    {
      fieldName: "transportType",
      title: "Transport Type",
      options: ["Passenger", "Freight"],
      placeholder: "Tap to select",
      type: "select",
    },
    {
      fieldName: "ownership",
      title: "Ownership",
      options: ["Company Owned", "Leased"],
      placeholder: "Tap to select",
      type: "select",
    },
    {
      fieldName: "logisticsVendor",
      title: "Logistics Vendor",
      type: "select",
      field: "logisticVendorLegalName",
      url: `${api}/master/scope1/logistic/vendorMaster`,
    },
    {
      fieldName: "vehicleNumber",
      title: "Vehicle Number",
      placeholder: "Type here",
    },
    {
      fieldName: "vehicleCategory",
      title: "Vehicle Category",
      options: [
        "Heavy Commercial Vehicles (HCV)",
        "Medium Commerical Vehicles (MCV)",
        "Light Commerical Vehicles (LCV)",
      ],
      type: "select",
    },
    {
      fieldName: "vehicleType",
      title: "Vehicle Type",
      type: "select",
    },
    {
      fieldName: "brand",
      title: "Brand",
      // type: "select",
      placeholder: "Type here",
      // url: `${api}/master/getAllBrand`,
    },
    {
      fieldName: "model",
      title: "Model",
      // type: "select",
      placeholder: "Type here",
      // url: `${api}/master/getAllModel`,
    },
    {
      fieldName: "purchaseDate",
      title: "Purchase Date",
      type: "date",
      placeholder: "dd/mm/yyyy",
    },
    {
      fieldName: "lastServiceDate",
      title: "Last Service Date",
      type: "date",
      placeholder: "dd/mm/yyyy",
    },
    {
      fieldName: "fuelType",
      title: "Fuel Type",
      options: [
        "Diesel (average biofuel blend)",
        "Diesel (100% mineral diesel)",
        "Petrol (average biofuel blend)",
        "Petrol (100% mineral petrol)",
        "CNG",
        "Electricity",
      ],
      type: "select",
    },
    {
      fieldName: "bharatStageEmissionType",
      title: "Bharat Stage Emission Type",
      options: [
        "India 2000 (Euro 1)",
        "BS II (Euro 2)",
        "BS III (Euro 3)",
        "BS IV (Euro 4)",
        "BS V (Euro 5)",
        "BS VI (Euro 6)",
      ],
      type: "select",
    },
    {
      fieldName: "declaredEfficiency",
      title: "Declared Efficiency",
      placeholder: "Enter Number",
    },
    {
      fieldName: "loadCapacity",
      title: "Load Capacity (tonnes)",
      placeholder: "Enter Number",
    },
    {
      fieldName: "passengerCapacity",
      title: "Passenger Capacity (persons)",
      placeholder: "Enter Number",
    },
    { fieldName: "uploadDocuments", title: "Upload Documents" },
    { fieldName: "pucDocs", title: "PUC Docs" },
    { fieldName: "pollutionDocs", title: "Pollution Docs" },
    { fieldName: "rcDocs", title: "RC Docs" },
    { fieldName: "insuranceDocs", title: "Insurance Docs" },
  ];

  const fetchUniqueValues = async () => {
    try {
      let res = await get(`${api}/master/scope1/getAllVehicle`);

      const vehicles = res.data.data;
      const uniqueModels = [
        ...new Set(vehicles.map((vehicle) => vehicle.model).filter(Boolean)),
      ];
      const uniqueBrands = [
        ...new Set(vehicles.map((vehicle) => vehicle.brand).filter(Boolean)),
      ];
      const uniqueTransportTypes = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.transportType).filter(Boolean)
        ),
      ];
      const uniqueOwnerships = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.ownership).filter(Boolean)
        ),
      ];
      const uniqueVendors = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.logisticsVendor).filter(Boolean)
        ),
      ];

      return {
        models: uniqueModels,
        brands: uniqueBrands,
        transportTypes: uniqueTransportTypes,
        ownerships: uniqueOwnerships,
        vendors: uniqueVendors,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();

      await get(`/master/scope1/getAllVehicle?${queryParams}`)
        .then(async (res) => {
          setData(res.data.data);
          console.log(res.data);
          setTotalPages(res.data.totalPages);
          const uniqueValues = await fetchUniqueValues();
          console.log(uniqueValues, "unique");
          setUniqueValues(uniqueValues);
        })
        .catch((err) => {
          console.log(err);
        });

      console.log(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, vehicle) => {
    setAnchorEl(event.currentTarget);
    setSelectedVehicle(vehicle);
    setVehicle(vehicle);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVehicle(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddVehicle(true);
    setViewVehicle(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewVehicle(true);
    setAddVehicle(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    transportType: tempFilter?.transportType,
    ownership: tempFilter?.ownership,
    logisticsVendor: tempFilter?.logisticsVendor,
    brand: tempFilter?.brand,
    model: tempFilter?.model,
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    fetchData(filtersToApply);
    setSelectedFields({
      transportType: tempFilter?.transportType,
      ownership: tempFilter?.ownership,
      logisticsVendor: tempFilter?.logisticsVendor,
      brand: tempFilter?.brand,
      model: tempFilter?.model,
    });
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      transportType: [],
      ownership: [],
      logisticsVendor: [],
      brand: [],
      model: [],
    });
    setTempFilter({
      startDate: null,
      endDate: null,
      transportType: [],
      ownership: [],
      logisticsVendor: [],
      brand: [],
      model: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isTransportTypeApplied =
      tempFilter.transportType?.length > 0 ? true : false;
    const isOwnershipApplied = tempFilter.ownership?.length > 0 ? true : false;
    const isLogisticsVendorApplied =
      tempFilter.logisticsVendor?.length > 0 ? true : false;
    const isBrandApplied = tempFilter.brand?.length > 0 ? true : false;
    const isModelApplied = tempFilter.model?.length > 0 ? true : false;

    setIsFiltersApplied(
      isDateApplied ||
        isTransportTypeApplied ||
        isOwnershipApplied ||
        isLogisticsVendorApplied ||
        isBrandApplied ||
        isModelApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Transport Type": isTransportTypeApplied,
      Ownership: isOwnershipApplied,
      "Logistics Vendor": isLogisticsVendorApplied,
      Brand: isBrandApplied,
      Model: isModelApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      transportType: selectedFields.transportType,
      ownership: selectedFields.ownership,
      logisticsVendor: selectedFields.logisticsVendor,
      brand: selectedFields.brand,
      model: selectedFields.model,
      startDate: startDate,
      endDate: endDate,
    });
    setDrawerFilterOpen(false);
    // filterResetWithoutApply();
    // setErrors({
    //   Date: false,
    //   Brand: false,
    //   Model: false,
    //   "Vehicle Category": false,
    //   "Vehicle Type": false,
    // });
  };

  const columnHeadings = [
    { title: "Date", field: "createdAt" },
    { title: "Transport Type", field: "transportType" },
    { title: "Ownership", field: "ownership" },
    { title: "Logistics Vendor", field: "logisticsVendor" },
    { title: "Brand", field: "brand" },
    { title: "Model", field: "model" },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Model":
        return (
          <MultiSelect
            title="Model"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  model: newValue.model || newValue,
                };
              });
            }}
            errors={errors.Model}
            setErrors={setErrors}
            field="model"
            data={uniqueValues?.models}
          />
        );
      case "Brand":
        return (
          <MultiSelect
            title="Brand"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  brand: newValue.brand || newValue,
                };
              });
            }}
            errors={errors.Brand}
            setErrors={setErrors}
            field="brand"
            data={uniqueValues?.brands}
          />
        );
      case "Logistics Vendor":
        return (
          <MultiSelect
            title="Logistics Vendor"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  logisticsVendor: newValue.logisticsVendor || newValue,
                };
              });
            }}
            errors={errors["Logistics Vendor"]}
            setErrors={setErrors}
            field="logisticsVendor"
            data={uniqueValues?.vendors}
          />
        );
      case "Ownership":
        return (
          <MultiSelect
            title="Ownership"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              console.log("first6", updater);
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  ownership: newValue.ownership || newValue,
                };
              });
            }}
            errors={errors.Ownership}
            setErrors={setErrors}
            data={uniqueValues?.ownerships}
            field="ownership"
          />
        );
      case "Transport Type":
        return (
          <MultiSelect
            title="Transport Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  transportType: newValue.transportType || newValue,
                };
              });
            }}
            errors={errors["Transport Type"]}
            setErrors={setErrors}
            field="transportType"
            data={uniqueValues?.transportTypes}
          />
        );
      default:
        return null;
    }
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            width: "100%",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddData
            id={vehicle ? vehicle._id : ""}
            addData={addVehicle}
            setAddData={setAddVehicle}
            data={data}
            element={vehicle}
            addUrl={`${api}/master/scope1/addVehicle`}
            updateUrl={`${api}/master/scope1/updateVehicle`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <ViewVehicle
            id={vehicle ? vehicle._id : ""}
            data={vehicle}
            viewData={viewVehicle}
            setViewData={setViewVehicle}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: vehicle._id,
                url: `${api}/master/scope1/deleteVehicle`,
                method: "put",
                setsnackOpen,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenu
            setData={setVehicle}
            setAddData={setAddVehicle}
            {...{
              heading: "Scope 1",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ flex: 1 }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <TableHeading heading={"Vehicle Master"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 17% 17% 20% 12% 13% 8%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.field,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((Vehicle) => (
                  <Box
                    key={Vehicle._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 17% 17% 20% 12% 13% 8%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.field}
                        {...{
                          fieldData:
                            el.field === "logisticsVendor"
                              ? Vehicle.logisticsVendor
                              : typeof Vehicle[el.field] === "object" &&
                                Vehicle[el.field] !== null
                              ? Vehicle[el.field]
                              : Vehicle[el.field],
                          dateField: el.field === "createdAt" ? Vehicle.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: Vehicle }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              totalPages={totalPages}
              page={page}
              handleChangePage={handleChangePage}
              StyledPaginationItem={StyledPaginationItem}
              isShortContent={isShortContent} // Pass this state to PaginationBox
            />
          )}
          <MenuActions
            {...{
              id: vehicle && vehicle._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Scope1Vehicle;
